import { getImageFromAssetFolder } from "../../../utils/assets";
import { openSocialMedia, SM } from "../../../utils/socialMedia";
import { APP_URL } from "../../../constants";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div
      // Adjusted padding for better mobile viewing (p-6) and desktop (md:p-12)
      className="p-6 md:p-12 w-full mt-16"
      // Theme color remains as requested
      style={{ background: "#0c2b49", overflow: "hidden" }}
    >
      {/* This is the main content row.
        - On small screens, it stacks columns vertically (flex-col).
        - On medium screens and up (md:), it becomes a row (md:flex-row) with a gap (md:gap-16).
        - It uses flex-wrap to allow content to wrap if necessary, though md:flex-row is primary.
      */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-16">
        {/* Company Info/Logo Section */}
        {/* On small screens, take full width (w-full). On medium screens, use flex-1 */}
        <div className="w-full md:flex-1 mt-2">
          <img
            preview={false}
            width={100}
            // Tailwind doesn't have a direct 'preview' prop, assuming it's an Antd img prop
            // The image size is fixed for the logo
            src={getImageFromAssetFolder("logo_text_white.png")}
          />

          <p className="text-white mt-1">Learn Beyond The Obvious</p>
          <hr className="w-[25%] mt-2"></hr>
          <p className="text-white text-sm mt-2">
            Turning effort into impact.{" "}
            <span className="text-nowrap">
              Smarter learning, guided by clarity and data.
            </span>
          </p>
        </div>

        {/* Company Links Section */}
        {/* On small screens, flex-none for content-based width; on medium screens, flex-1 */}
        <div className="flex-none md:flex-1">
          <h5 className="text-white font-semibold text-xl mb-2">Company</h5>
          <div className="flex flex-col gap-1">
            <Link to={"/about-us"} className="text-white">
              About Us
            </Link>{" "}
            <Link to={"/legal/privacy-policies"} className="text-white">
              Privacy Policies
            </Link>{" "}
            <Link to={"/legal/terms-of-use"} className="text-white">
              Terms & Conditions
            </Link>
            <Link to={"/legal/user-policies"} className="text-white">
              User Policies
            </Link>
          </div>
        </div>

        {/* Product & Services Section */}
        {/* On small screens, flex-none for content-based width; on medium screens, flex-1 */}
        <div className="flex-none md:flex-1">
          <h5 className="text-white font-semibold text-xl mb-2">
            Product & Services
          </h5>
          <div className="flex flex-col gap-1">
            <p className="text-white">Syllabus Tracking</p>
            <p className="text-white">Supplementary Contents</p>
            <p className="text-white">Support & Guidance</p>
            <p className="text-white">Career Counseling</p>
          </div>
        </div>
      </div>

      <hr className="mt-8 mb-8" />

      {/* Copyright and Social Media Section
        - On small screens, stack vertically (flex-col) and center items (items-center).
        - On small/medium screens and up (sm:), revert to row (sm:flex-row) and justify-between.
      */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
        <p
          className="block text-center sm:text-left text-sm"
          style={{ color: "#fff" }}
        >
          Copyright © 2024 ZeroEqualOne: Learn Beyond The Obvious. All rights
          reserved.
        </p>
        <div className="flex gap-2">
          {/* Social Media Icons */}
          <img
            src="/assets/sm/facebook.svg"
            className="w-[32px] h-[32px] bg-white rounded-full p-0.5 cursor-pointer"
            onClick={() => openSocialMedia(SM.FB)}
            alt="Facebook"
          />
          <img
            src="/assets/sm/linkedin.svg"
            className="w-[32px] h-[32px] bg-white rounded-full p-0.5 cursor-pointer"
            onClick={() => openSocialMedia(SM.IN)}
            alt="LinkedIn"
          />
          <img
            src="/assets/sm/instagram.svg"
            className="w-[32px] h-[32px] bg-white rounded-full p-0.5 cursor-pointer"
            onClick={() => openSocialMedia(SM.INSTA)}
            alt="Instagram"
          />
          <img
            src="/assets/sm/x.svg"
            className="w-[32px] h-[32px] bg-white rounded-full p-0.5 cursor-pointer"
            onClick={() => openSocialMedia(SM.X)}
            alt="X (formerly Twitter)"
          />
          <img
            src="/assets/sm/youtube.svg"
            className="w-[32px] h-[32px] bg-white rounded-full p-0.5 cursor-pointer"
            onClick={() => openSocialMedia(SM.YT)}
            alt="YouTube"
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
